import { useMobileMenuContext } from "@/components/layouts/MobileMenuProvider.tsx";
import { NavbarMobileOverlay } from "@/components/layouts/NavbarMobileOverlay.tsx";
import { Div, Divider } from "@hopper-ui/components";
import { useGetCurrentUserSuspenseQuery, useSharedTranslation } from "@workleap-ai/shared";
import { WorkleapNavbar } from "@workleap-platform/navbar/react";

import "./Navbar.dark.css";

export const Navbar = () => {
    const { data: { showNavbarSettings } } = useGetCurrentUserSuspenseQuery();
    const { tShared } = useSharedTranslation();
    const { isMobileMenuOpen, toggleMobileMenu } = useMobileMenuContext();

    return (
        <Div
            position="relative"
            UNSAFE_minHeight="var(--wai-navbar-height)"
            gridArea="navbar"
            className="wai-navbar"
        >
            {isMobileMenuOpen && <NavbarMobileOverlay />}
            <WorkleapNavbar
                data={{
                    title: tShared("workleapAi"),
                    features: {
                        aiAssistant: false,
                        aiSearchBar: false,
                        settings: showNavbarSettings
                    },
                    hamburger: { onClick: toggleMobileMenu }
                }}
            />
            {/* Divider to display the bottom bottom of the Navbar as soon as possible */}
            <Divider
                position="absolute"
                bottom="0"
                left="0"
                zIndex={0}
                width="100%"
                margin="core_0"
            />
        </Div>
    );
};
